import { Injectable } from '@angular/core';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';

declare let google: any;

/**
 * Service to perform google api related services
 */
@Injectable()
export class GoogleService {
    constructor(private http: HttpServiceHelper) {
    }

    public getGooglePlace(googlePlaceId: string, callback: (googlePlace: any) => void): void {
        if (!googlePlaceId) {
            callback(null);
            return;
        }

        try {
            // Load the Google place
            const request: any = {
                placeId: googlePlaceId,
            };

            let map: any = document.getElementById('google-map');

            if (!map) {
                map = document.createElement('div');
                map.setAttribute('id', 'google-map');
                map.setAttribute('style', 'display:none');
            }

            const service: any = new google.maps.places.PlacesService(map);

            service.getDetails(request, (place: any) => {
                callback(place);
            });
        } catch (e) {
            this.http.toastService.showError(
                'An error occurred trying to load the location address provided by Google places',
            );
        }
    }
}
